import React from 'react';
import { Loader } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import toast from 'react-hot-toast';

import { useLazyShowMoreContactsQuery } from '../../../services/sharedCompanyListV2';

export const ShowMoreContacts = ({
  currentContactsCount,
  contactsCount,
  contactsSource,
  networkId,
  sharedListId,
  companyId,
  queryParams,
  isPublicList,
}) => {
  const [showMoreContacts, { isLoading }] = useLazyShowMoreContactsQuery();
  const { page, ...restQueryParams } = queryParams;

  const onClickShowMoreContacts = () => {
    const payload =
      contactsSource === 'my-contacts'
        ? { companyIds: [companyId], onlyMyContacts: true, networkId }
        : { companyIds: [companyId], networkId: contactsSource };

    if (isPublicList) {
      payload.contextualizedToSharedListId = sharedListId;
    } else {
      payload.sharedListId = sharedListId;
      payload.sharedListIds = [sharedListId];
    }

    showMoreContacts({ ...payload, ...restQueryParams }).catch(() => {
      toast('Couldn’t load more contacts, please try again.', { type: 'error' });
    });
  };

  return (
    <Flex alignItems="center" p="8px" width="100%" sx={{ gap: '4px' }}>
      {isLoading && (
        <Flex alignItems="center" sx={{ gap: '8px' }}>
          <Loader size="small" />
          <Text fontSize="12px" color="text.subtle">
            Loading more contacts...
          </Text>
        </Flex>
      )}
      {!isLoading && (
        <>
          <Text fontSize="12px" color="text.subtle">
            Showing top {currentContactsCount ?? 5} contacts
          </Text>
          <Text fontSize="12px" color="text.subtle">
            ·
          </Text>
          <Text
            fontSize="12px"
            color="text.subtle"
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={onClickShowMoreContacts}
          >
            {`Show all ${contactsCount} contacts`}
          </Text>
        </>
      )}
    </Flex>
  );
};

ShowMoreContacts.propTypes = {
  contactsCount: PropTypes.number,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  contactsSource: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  networkId: PropTypes.number.isRequired,
  sharedListId: PropTypes.number.isRequired,
  queryParams: PropTypes.object,
  isPublicList: PropTypes.bool,
  currentContactsCount: PropTypes.number,
};

ShowMoreContacts.defaultProps = {
  contactsCount: 0,
  queryParams: {},
  isPublicList: false,
  currentContactsCount: null,
};
